import { defineComponent as _defineComponent } from 'vue'
import ResponseModalContent from './ResponseModalContent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'VacancyModalContainer',
  props: {
  modelValue: { type: Boolean, default: false },
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose }) {
  __expose();




const __returned__ = { ResponseModalContent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})